module.exports = __webpack_public_path__ + "static/media/Poppins-ThinItalic.32743a4d.ttf";